"use client";

import { useEffect } from "react";
import { resolveAreaSport } from "./area-g3-format";
import { AREA_SPORT_PARAM, useAreaSport } from "./area-sport-state";

/**
 * Keeps the sport scope's `data-area-sport` attribute (AreaSportScope) on the URL's sport after
 * hydration and on every pick. The attribute drives the scope's style rules, so every panel on
 * the page switches together without re-rendering any server-rendered panel. The effect reads the
 * location itself (not the hydration snapshot), so it never undoes the pre-paint script's pick.
 * Renders nothing.
 */
export function AreaSportSync({ primary, keys }: Readonly<{ primary: string; keys: readonly string[] }>) {
  const sport = useAreaSport(primary, keys);
  useEffect(() => {
    const root = document.querySelector<HTMLElement>("[data-area-sport-root]");
    if (!root) return;
    const actual = resolveAreaSport(
      { param: new URLSearchParams(window.location.search).get(AREA_SPORT_PARAM), hash: window.location.hash },
      keys,
      primary,
    );
    if (root.dataset.areaSport !== actual) root.dataset.areaSport = actual;
  }, [sport, keys, primary]);
  return null;
}
